import { FC } from 'react'
import { Button as MuiButton, styled } from '@mui/material'
import { Loader } from 'packages/eid-ui'

export interface ButtonProps {
    onClick: any
    isLoading?: boolean
    disabled?: boolean
    variant?: 'blue' | 'green' | 'default'
    endIcon?: any
    children?: React.ReactNode
}

const getButtonStyles = (variant: string, theme: any) => {
    switch (variant) {
        case 'green':
            return {
                backgroundColor: 'transparent',
                border: 'solid 1px #01ae8f',
                color: '#01ae8f',
                '&:hover': {
                    backgroundColor: '#01ae8f',
                    color: 'white',
                },
            }
        case 'blue':
            return {
                backgroundColor: 'transparent',
                border: `solid 1px ${theme.palette.primary.main}`,
                color: theme.palette.primary.main,
                '&:hover': {
                    backgroundColor: theme.palette.primary.main,
                    color: 'white',
                },
            }
        default:
            return {
                backgroundColor: '#ffffff',
                border: `solid 1px ${theme.palette.primary.main}`,
                color: theme.palette.primary.main,
            }
    }
}

const StyledButton = styled(MuiButton)<{ btnVariant: string }>(
    ({ theme, btnVariant }) => ({
        height: '31px',
        borderRadius: '16px',
        boxShadow: '0 0 0 0',
        textTransform: 'capitalize',
        ...getButtonStyles(btnVariant, theme),
    }),
)

export const Button: FC<ButtonProps> = ({
    onClick,
    isLoading,
    disabled,
    variant = 'default',
    endIcon,
    children,
}) => (
    <StyledButton
        size="small"
        onClick={onClick}
        disabled={disabled}
        endIcon={endIcon}
        btnVariant={variant}
    >
        {isLoading ? <Loader size={0.6} /> : children}
    </StyledButton>
)
